import { TP_Building } from "./types";
import { OverviewPanel as EdgeDeviceView } from '../../../Devices/EdgeDevice/EdgeDevicesView'

const SystemPanel = (props: TP_Building) => {

    return (

        <EdgeDeviceView parentId={props.id} parentResouceGroupId={props.resourceGroupId}></EdgeDeviceView>
    )
}

export default SystemPanel;